module.exports = __webpack_public_path__ + "static/media/HE-Labs-01-1.5c7b5875.jpg";